import { useMutation, useQueryClient } from "@tanstack/react-query";
import { updateProgramFunction } from "../../services/programFunction";
import { IIndicators } from "../../types";
import { toast } from "react-toastify";

const useUpdateProgramFunction = (indicators: IIndicators) => {
    const queryClient = useQueryClient();

    return useMutation({
        mutationFn: updateProgramFunction,

        onMutate: () => {
            indicators.setIsProcessRunning(true);
        },

        onSuccess: (status) => {
            if (status === 200) {
                indicators.setIsProcessRunning(false);
                queryClient.invalidateQueries({ queryKey: ['categories'] });
                toast.success("Program function updated successfully");
            }
        },

        onError: (error: any) => {
            indicators.setIsProcessRunning(false);
            indicators.setIsServiceError(error.response?.data?.message);
            toast.error(error.response?.data?.message);
        }
    });
}

export default useUpdateProgramFunction;